
import { Component, Output, OnInit, EventEmitter, Input, HostListener, ElementRef, ViewChildren, QueryList } from '@angular/core';
import * as $ from 'jquery';
import { CairoService } from './cairo.service';
import { AuthService } from '../auth/auth.service';
import { swatchPair, xyzFromParams, xyzToLch, XYZ } from './color';




@Component({
    selector: 'fittings-customer-selector',
    template: `
        <div class="popup">
            <button type="button" class="popup-btn" (click)="toggle()">
                <span class="popup-val" [class.placeholder]="!selected">{{ selected || 'Select…' }}</span>
                <span class="chev"><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </button>
            <div class="menu" [class.open]="open">
                <button type="button" *ngFor="let c of customers" [class.selected]="c === selected" (click)="pick(c)">
                    <span class="check">✓</span>{{ c }}
                </button>
            </div>
        </div>
    `
})
export class CustomerSelectorComponent implements OnInit {

    @Output() onSelection = new EventEmitter<string>();

    constructor(private srv: AuthService, private el: ElementRef) { }
    private customers: string[] = [];
    open: boolean = false;
    selected: string = '';

    ngOnInit() {
        this.customers = this.srv.shops_list();
        if (this.customers.length > 0) {
            this.selected = this.customers[0];
            this.onSelection.emit(this.customers[0]);
        } else {
            this.onSelection.emit(this.srv.shop_id())
        }
    }

    get value(): string { return this.selected; }
    toggle() { this.open = !this.open; }
    pick(c: string) { this.selected = c; this.open = false; this.onSelection.emit(c); }

    @HostListener('document:click', ['$event'])
    onDocClick(e: MouseEvent) {
        if (this.open && !this.el.nativeElement.contains(e.target)) { this.open = false; }
    }
}


@Component({
    selector: 'fittings-machine-selector',
    template: `
        <div class="popup">
            <button type="button" class="popup-btn" (click)="toggle()">
                <span class="popup-val" [class.placeholder]="!selected">{{ selected ? label(selected) : 'Select…' }}</span>
                <span class="chev"><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </button>
            <div class="menu" [class.open]="open">
                <button type="button" *ngFor="let m of machines" [class.selected]="m === selected" (click)="pick(m)">
                    <span class="check">✓</span>{{ label(m) }}
                </button>
            </div>
        </div>
    `
})
export class MachineSelectorComponent implements OnInit {

    @Output() onSelection = new EventEmitter<string>();

    constructor(private srv: CairoService, private auth: AuthService, private el: ElementRef) { }
    private machines: any[] = [];
    open: boolean = false;
    selected: any = null;

    ngOnInit() {
        let mycustomer = this.auth.shop_id();
        if (mycustomer) {
            this.load(mycustomer);
        }
    }

    public load(customer: string) {
        this.srv.machines(customer).then((m: any[]) => {
            this.machines = m;
            if (this.machines.length > 0) {
                this.selected = this.machines[0];
                this.onSelection.emit(this.machines[0].name);
            }
        });
    }

    get value(): string { return this.selected ? this.selected.name : ''; }
    /** "01 - Satis 1200 Valencia" when the customer named the machine (machineNames in cairo.json), else "01". */
    label(m: any): string { return m.alias ? `${m.name} - ${m.alias}` : m.name; }
    toggle() { this.open = !this.open; }
    pick(m: any) { this.selected = m; this.open = false; this.onSelection.emit(m.name); }

    @HostListener('document:click', ['$event'])
    onDocClick(e: MouseEvent) {
        if (this.open && !this.el.nativeElement.contains(e.target)) { this.open = false; }
    }
}


@Component({
    selector: 'fittings-recipe-selector',
    template: `
        <div class="popup">
            <button type="button" class="popup-btn" (click)="toggle()">
                <span class="popup-val" [class.placeholder]="!selected">{{ selected ? selected.alias : 'Select…' }}</span>
                <span class="chev"><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </button>
            <div class="menu" [class.open]="open">
                <button type="button" *ngFor="let r of recipes" [class.selected]="r === selected" (click)="pick(r)">
                    <span class="check">✓</span>{{ r.alias }}
                </button>
            </div>
        </div>
    `
})
export class RecipeSelectorComponent {

    @Output() onSelection = new EventEmitter<string>();
    constructor(private srv: CairoService, private el: ElementRef) { }
    private recipes: any[] = [];
    open: boolean = false;
    selected: any = null;

    public load(customer: string, machine: string) {
        this.selected = null;
        this.srv.recipes(customer, machine).then((r: any[]) => {
            this.recipes = r;
            if (this.recipes.length > 0) {
                this.selected = this.recipes[0];
                this.onSelection.emit(this.recipes[0].name);
            }
        });
    }

    get value(): string { return this.selected ? this.selected.name : ''; }
    toggle() { this.open = !this.open; }
    pick(r: any) { this.selected = r; this.open = false; this.onSelection.emit(r.name); }

    @HostListener('document:click', ['$event'])
    onDocClick(e: MouseEvent) {
        if (this.open && !this.el.nativeElement.contains(e.target)) { this.open = false; }
    }
}


@Component({
    selector: 'fittings-substrate-selector',
    template: `
        <div class="popup">
            <button type="button" class="popup-btn" (click)="toggle()">
                <span class="popup-val" [class.placeholder]="!selected">{{ selected || 'Select…' }}</span>
                <span class="chev"><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </button>
            <div class="menu" [class.open]="open">
                <button type="button" *ngFor="let s of substrates" [class.selected]="s === selected" (click)="pick(s)">
                    <span class="check">✓</span>{{ s }}
                </button>
            </div>
        </div>
    `
})
export class SubstrateSelectorComponent {

    constructor(private srv: CairoService, private el: ElementRef) { }
    private substrates: string[] = [];
    open: boolean = false;
    selected: string = '';

    public load(customer: string, machine: string, recipe: string) {
        this.selected = '';
        this.srv.substrates(customer, machine, recipe).then((s: string[]) => {
            this.substrates = s;
            this.selected = (s && s.length > 0) ? s[0] : '';
        });
    }

    get value(): string { return this.selected; }
    toggle() { this.open = !this.open; }
    pick(s: string) { this.selected = s; this.open = false; }

    @HostListener('document:click', ['$event'])
    onDocClick(e: MouseEvent) {
        if (this.open && !this.el.nativeElement.contains(e.target)) { this.open = false; }
    }
}

@Component({
    selector: 'fittings-spectrophotometer',
    template: `
        <div class="popup">
            <button type="button" class="popup-btn" (click)="toggle()">
                <span class="popup-val" [class.placeholder]="!selected">{{ selected ? selected.name : 'Select…' }}</span>
                <span class="chev"><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            </button>
            <div class="menu" [class.open]="open">
                <button type="button" *ngFor="let s of spectrophotometers" [class.selected]="s === selected" (click)="pick(s)">
                    <span class="check">✓</span>{{ s.name }}
                </button>
            </div>
        </div>
    `
})
export class SpectrophotometerComponent implements OnInit {

    constructor(private srv: CairoService, private el: ElementRef) { }
    private spectrophotometers: any[] = [];
    open: boolean = false;
    selected: any = null;

    ngOnInit() {
        this.spectrophotometers = this.srv.spectrophotometers();
        if (this.spectrophotometers.length > 0) {
            this.selected = this.spectrophotometers[0];
        }
    }

    /** Narrows the list to the machine's spectrophotometers (see CairoService.spectrophotometersFor). */
    load(customer: string, machine: string) {
        this.srv.spectrophotometersFor(customer, machine).then(list => {
            this.spectrophotometers = list;
            if (this.spectrophotometers.indexOf(this.selected) < 0) {
                this.selected = this.spectrophotometers.length > 0 ? this.spectrophotometers[0] : null;
            }
        });
    }

    get value(): string { return this.selected ? this.selected.id : ''; }
    toggle() { this.open = !this.open; }
    pick(s: any) { this.selected = s; this.open = false; }

    @HostListener('document:click', ['$event'])
    onDocClick(e: MouseEvent) {
        if (this.open && !this.el.nativeElement.contains(e.target)) { this.open = false; }
    }
}

@Component({
    selector: 'value-pair-card',
    template: `
        <div class="lcard" [class.metric]="both_readonly">
            <div class="top">
                <div class="m"><span class="dot" *ngIf="!both_readonly"></span>{{ name }}</div>
            </div>
            <div class="row cur">
                <div class="fld">
                    <input id="{{id}}-old" [attr.readonly]="both_readonly ? true : null"
                        [attr.tabindex]="both_readonly ? -1 : null" type="number" placeholder="current"
                        (input)="current = $event.target.value">
                    <span class="unit">{{ unitText }}</span>
                </div>
            </div>
            <div class="row tgt">
                <div class="fld">
                    <input id="{{id}}-new" readonly tabindex="-1" type="number" placeholder="target" value="{{ new_value }}">
                    <span class="unit">{{ unitText }}</span>
                </div>
            </div>
        </div>
    `
})
export class PairTableComponent {
    @Input() id: string;
    @Input() name: string;
    @Input() units: string = 'nm';
    @Input() both_readonly: boolean = false;
    @Input() index: any = null;

    /** What the user typed in the "current" field ('' while empty or not a valid number). */
    public current: string = '';

    get unitText(): string {
        const map: { [k: string]: string } = { nm: 'nm', percentage: '%', degree: '°' };
        return map[this.units] || '';
    }

}

@Component({
    selector: 'layers-values',
    template: `
        <div *ngIf="error" class="warn-card">
            <h5>Warning</h5>
            <p>Something went wrong. Please contact
                <a href="mailto:coatings@horizonsoptical.com">coatings@horizonsoptical.com</a>
            </p>
        </div>
        <div *ngIf="!error" class="card-stack">
            <value-pair-card *ngFor="let layer of make_array(); let i = index;"
                [name]="layers[i]" [id]="i" [index]="i + 1"></value-pair-card>
        </div>
    `
})
export class TableValuesComponent {
    private layers: string[] = [];
    @ViewChildren(PairTableComponent) private cards: QueryList<PairTableComponent>;

    private make_array(): any[] {
        return Array(this.layers.length);
    }    

    constructor(private srv: CairoService) { }
    public load(customer: string, machine: string, recipe: string) {
        this.srv.layers(customer, machine, recipe).then((layers: string[]) => {
            this.layers = layers;
        });
    }

    /** True when the recipe has layers and every one has a current thickness. */
    public get complete(): boolean {
        return this.layers.length > 0 && !!this.cards
            && this.cards.length === this.layers.length
            && this.cards.toArray().every(card => card.current.trim() !== '');
    }

    public get_layers() {
        return this.layers.map((name, idx) => {
            return $('#' + idx + '-old')[0].value;
        })
    }

    private readonly DecimalsMap = {
        Rvis: 2,
        L: 1,
        Chroma: 1,
        Hue: 0,
    }    
    
    private round(key: string, value: number): number {
        if (key in this.DecimalsMap) {
            const f = Math.pow(10, this.DecimalsMap[key]);
            return Math.round(value * f) / f;
        }
        return value;
    }

    /** Writes a "current" metric (Rvis, L, Chroma, Hue), flagging it as an estimate or not. */
    private setCurrent(key: string, value: number | null, preliminary: boolean) {
        const el = $('#' + key + '-old');
        if (el.length === 0) { return; }
        el[0].value = value === null ? '' : this.round(key, value);
        const estimate = preliminary && value !== null;
        el.toggleClass('prelim', estimate);
        if (estimate) {
            el.attr('title', 'Estimated from the imported curve (no reference correction). Calculate to get the measured value.');
        } else {
            el.removeAttr('title');
        }
    }

    /**
     * Fills the "current" side of the colorimetry cards with the estimate
     * computed in the browser from the imported spectrum. Pass null to clear.
     */
    public showPreliminary(xyz: XYZ | null) {
        const lch = xyz ? xyzToLch(xyz) : null;
        this.setCurrent('Rvis', xyz ? xyz.Y * 100 : null, true);
        this.setCurrent('L', lch ? lch.L : null, true);
        this.setCurrent('Chroma', lch ? lch.C : null, true);
        this.setCurrent('Hue', lch ? lch.h : null, true);
    }

    private error: boolean = false;
    private result : boolean = false;
    public show(results) {
        this.error = (results.debug.CSQ2 > (results.debug.CSQ1 * 0.75));

        results.layers.forEach((value, idx) => {
            $('#' + idx + '-new')[0].value = value;
        });

        this.result = true;

        results.parameters.forEach(param => {
            this.setCurrent(param.key, Number(param.value), false);
        });

        results.target_parameters.forEach(param => {
            let key = param.key.substr(1);
            let value = param.value
            if (key in this.DecimalsMap) {
                value = Math.round(value * Math.pow(10, this.DecimalsMap[key])) /  Math.pow(10, this.DecimalsMap[key]);
            }
            const el = $('#' + key + '-new')[0];
            if (el) { el.value = value; }
        });
    }
}

@Component({
    selector: 'color-swatch-card',
    template: `
        <div class="lcard metric swatch">
            <div class="top">
                <div class="m">Color</div>
            </div>
            <div class="pair">
                <div class="sw cur" [class.prelim]="preliminary">
                    <div class="chip" [class.empty]="!current" [style.background]="current || null"
                        title="{{ current ? (preliminary ? 'estimated from the imported curve (no reference correction): ' : 'measured: ') + current : 'measured' }}"></div>
                    <div class="cap"><span>{{ preliminary ? 'current · est.' : 'current' }}</span><span class="hex">{{ current || '' }}</span></div>
                </div>
                <div class="sw tgt">
                    <div class="chip" [class.empty]="!target" [style.background]="target || null"
                        title="{{ target ? 'target: ' + target : 'target' }}"></div>
                    <div class="cap"><span>target</span><span class="hex">{{ target || '' }}</span></div>
                </div>
            </div>
        </div>
    `
})
export class ColorSwatchComponent {
    /** sRGB hex of the measured sample, null until a file is imported or a job has run. */
    public current: string | null = null;
    /** sRGB hex of the target colour, null until a job has run. */
    public target: string | null = null;
    /** True while `current` comes from the client-side estimate, not from the backend. */
    public preliminary: boolean = false;

    public clear() {
        this.current = null;
        this.target = null;
        this.preliminary = false;
    }

    /**
     * Shows the colour estimated in the browser from the imported spectrum.
     * The target swatch is cleared: it belongs to the previous job, if any.
     */
    public showPreliminary(xyz: XYZ | null) {
        this.current = xyz ? swatchPair(xyz, null).current : null;
        this.target = null;
        this.preliminary = this.current !== null;
    }

    /**
     * Derives both swatches from the job result. Uses X, Y, Z from
     * `parameters` / `target_parameters` when present, otherwise L, Chroma, Hue.
     */
    public show(results) {
        const toMap = (list: any[], strip: boolean) => {
            const m: { [key: string]: number } = {};
            (list || []).forEach(p => {
                const key = strip ? String(p.key).substr(1) : String(p.key);
                m[key] = Number(p.value);
            });
            return m;
        };
        const cur = xyzFromParams(toMap(results.parameters, false));
        const tgt = xyzFromParams(toMap(results.target_parameters, true));
        const pair = swatchPair(cur, tgt);
        this.current = pair.current;
        this.target = pair.target;
        this.preliminary = false;
    }
}
